var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-row",
        { staticClass: "pa-4" },
        [
          _c("v-text-field", {
            staticClass: "pr-2",
            attrs: { label: _vm.$t("settings.tripPolicy.title") },
            model: {
              value: _vm.title,
              callback: function($$v) {
                _vm.title = $$v
              },
              expression: "title"
            }
          }),
          _c("v-text-field", {
            staticClass: "px-2",
            attrs: { label: _vm.$t("settings.customWebpage.headers.alias") },
            model: {
              value: _vm.alias,
              callback: function($$v) {
                _vm.alias = $$v
              },
              expression: "alias"
            }
          }),
          _c("v-text-field", {
            staticClass: "px-2",
            attrs: {
              label: _vm.$t("settings.customWebpage.icon"),
              "append-outer-icon": _vm.icon
            },
            model: {
              value: _vm.icon,
              callback: function($$v) {
                _vm.icon = $$v
              },
              expression: "icon"
            }
          }),
          _c("v-spacer"),
          _c(
            "v-btn",
            { staticClass: "accent", on: { click: _vm.save } },
            [
              _vm._v(_vm._s(_vm.$t("global.save")) + " "),
              _c("v-icon", [_vm._v("border_color")])
            ],
            1
          )
        ],
        1
      ),
      _c("quill-editor", {
        ref: "myQuillEditor",
        attrs: { options: _vm.quillOptions },
        model: {
          value: _vm.html,
          callback: function($$v) {
            _vm.html = $$v
          },
          expression: "html"
        }
      }),
      _c("ajax-file", {
        attrs: { items: _vm.files, assignment: "custom_webpage" }
      }),
      _c("h2", { staticStyle: { "margin-top": "35px" } }, [
        _vm._v(_vm._s(_vm.$t("settings.tripPolicy.preview")) + ":")
      ]),
      _c("h1", [_vm._v(_vm._s(_vm.title))]),
      _c(
        "div",
        {
          staticClass: "ql-container ql-snow",
          staticStyle: { border: "none" }
        },
        [
          _c("div", {
            staticClass: "ql-editor",
            domProps: { innerHTML: _vm._s(_vm.html) }
          })
        ]
      ),
      _c("multiple-file-download", {
        attrs: { files: _vm.files },
        on: {
          download: function(fileId) {
            return _vm.download(fileId)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }